export const GET_PROJECTS_REQ = 'GET_PROJECTS_REQ';
export const GET_PROJECTS_OK = 'GET_PROJECTS_OK';

export const GET_PREDEFINED_PROJECTS_REQ = 'GET_PREDEFINED_PROJECTS_REQ';
export const GET_PREDEFINED_PROJECTS_OK = 'GET_PREDEFINED_PROJECTS_OK';

export const ADD_PROJECT_REQ = 'ADD_PROJECT_REQ';
export const ADD_PROJECT_OK = 'ADD_PROJECT_OK';
export const ADD_PROJECT_ERR = 'ADD_PROJECT_ERR';

export const ADD_PROJECT_BY_TEMPLATE_REQ = 'ADD_PROJECT_BY_TEMPLATE_REQ';
export const ADD_PROJECT_BY_TEMPLATE_OK = 'ADD_PROJECT_BY_TEMPLATE_OK';
export const ADD_PROJECT_BY_TEMPLATE_ERR = 'ADD_PROJECT_BY_TEMPLATE_ERR';

export const DELETE_PROJECT_REQ = 'DELETE_PROJECT_REQ';
export const DELETE_PROJECT_OK = 'DELETE_PROJECT_OK';
export const DELETE_PROJECT_ERR = 'DELETE_PROJECT_ERR';

export const RENAME_PROJECT_REQ = 'RENAME_PROJECT_REQ';
export const RENAME_PROJECT_OK = 'RENAME_PROJECT_OK';

export const RECONNECT_PROJECT_REQ = 'RECONNECT_PROJECT_REQ';
export const RECONNECT_PROJECT_OK = 'RECONNECT_PROJECT_OK';

export const DISCONNECT_PROJECT_REQ = 'DISCONNECT_PROJECT_REQ';
export const DISCONNECT_PROJECT_OK = 'DISCONNECT_PROJECT_OK';

export const GET_PROJECT_INFO_REQ = 'GET_PROJECT_INFO_REQ';
export const GET_PROJECT_INFO_OK = 'GET_PROJECT_INFO_OK';

export const GET_PROJECT_REQ = 'GET_PROJECT_REQ';
export const GET_PROJECT_OK = 'GET_PROJECT_OK';

export const REORDER_PROJECTS_REQ = 'REORDER_PROJECTS_REQ';
export const REORDER_PROJECTS_OK = 'REORDER_PROJECTS_OK';

export const GET_SCRIPTS_REQ = 'GET_SCRIPTS_REQ';
export const GET_SCRIPTS_IN_PROCESS = 'GET_SCRIPTS_IN_PROCESS';
export const GET_SCRIPTS_OK = 'GET_SCRIPTS_OK';

export const CREATE_SCRIPT_REQ = 'CREATE_SCRIPT_REQ';
export const CREATE_SCRIPT_OK = 'CREATE_SCRIPT_OK';
export const CREATE_SCRIPT_ERR = 'CREATE_SCRIPT_ERR';

export const IMPORT_FILES_REQ = 'IMPORT_FILES_REQ';
export const IMPORT_FILES_OK = 'IMPORT_FILES_OK';
export const IMPORT_FILES_RESET = 'IMPORT_FILES_RESET';
export const IMPORT_FILES_ERR = 'IMPORT_FILES_ERR';

export const ACTUAL_STATUS_FOR_SCRIPTS_REQ = 'ACTUAL_STATUS_FOR_SCRIPTS_REQ';
export const ACTUAL_STATUS_FOR_SCRIPTS_OK = 'ACTUAL_STATUS_FOR_SCRIPTS_OK';
export const ACTUAL_STATUS_FOR_SCRIPTS_ERR = 'ACTUAL_STATUS_FOR_SCRIPTS_ERR';

export const GET_ACTIVE_PATTERNS_REQ = 'GET_ACTIVE_PATTERNS_REQ';
export const GET_ACTIVE_PATTERNS_OK = 'GET_ACTIVE_PATTERNS_OK';

export const UPDATE_SCRIPTS_REQ = 'UPDATE_SCRIPTS_REQ';
export const UPDATE_SCRIPTS_OK = 'UPDATE_SCRIPTS_OK';
export const SCRIPT_WAS_UPDATED_SHOW_STATUS = 'SCRIPT_WAS_UPDATED_SHOW_STATUS';
export const SCRIPT_WAS_UPDATED_HIDE_STATUS = 'SCRIPT_WAS_UPDATED_HIDE_STATUS';

export const UPDATE_SCRIPT_REQ = 'UPDATE_SCRIPT_REQ';
export const UPDATE_SCRIPT_OK = 'UPDATE_SCRIPT_OK';

export const SET_SAVING_STATUS_FOR_SCRIPTS_REQ = 'SET_SAVING_STATUS_FOR_SCRIPTS_REQ';
export const SET_SAVING_STATUS_FOR_SCRIPTS_OK = 'SET_SAVING_STATUS_FOR_SCRIPTS_OK';

export const DELETE_SCRIPT_REQ = 'DELETE_SCRIPT_REQ';
export const DELETE_SCRIPT_OK = 'DELETE_SCRIPT_OK';

export const DISCARD_SCRIPT_CHANGES_REQ = 'DISCARD_SCRIPT_CHANGES_REQ';
export const DISCARD_SCRIPT_CHANGES_OK = 'DISCARD_SCRIPT_CHANGES_OK';

export const REORDER_SCRIPTS_REQ = 'REORDER_SCRIPTS_REQ';
export const REORDER_SCRIPTS_OK = 'REORDER_SCRIPTS_OK';

export const REORDER_CONVERSATIONS_REQ = 'REORDER_CONVERSATIONS_REQ';
export const REORDER_CONVERSATIONS_OK = 'REORDER_CONVERSATIONS_OK';

export const RENAME_SCRIPT_REQ = 'RENAME_SCRIPT_REQ';
export const RENAME_SCRIPT_OK = 'RENAME_SCRIPT_OK';

export const EXPORT_SCRIPT_REQ = 'EXPORT_SCRIPT_REQ';
export const EXPORT_SCRIPT_OK = 'EXPORT_SCRIPT_OK';

export const DUPLICATE_SCRIPT_REQ = 'DUPLICATE_SCRIPT_REQ';
export const DUPLICATE_SCRIPT_OK = 'DUPLICATE_SCRIPT_OK';

export const SET_RELOAD_FLAG_IN_PROJECT = 'SET_RELOAD_FLAG_IN_PROJECT';
export const UNSET_RELOAD_FLAG_IN_PROJECT = 'UNSET_RELOAD_FLAG_IN_PROJECT';

export const MAKE_SCRIPTS_EDITABLE_REQ = 'MAKE_SCRIPTS_EDITABLE_REQ';
export const MAKE_SCRIPTS_EDITABLE_OK = 'MAKE_SCRIPTS_EDITABLE_OK';

export const ADD_PROJECT_TAG_REQ = 'ADD_PROJECT_TAG_REQ';
export const ADD_PROJECT_TAG_OK = 'ADD_PROJECT_TAG_OK';

export const CHANGE_TAG_ID_IN_PROJECT = 'CHANGE_TAG_ID_IN_PROJECT';

export const SET_UP_PROJECT_TAG_REQ = 'SET_UP_PROJECT_TAG_REQ';

export const RENAME_PROJECT_TAG_REQ = 'RENAME_PROJECT_TAG_REQ';
export const RENAME_PROJECT_TAG_OK = 'RENAME_PROJECT_TAG_OK';

export const DELETE_PROJECT_TAG_REQ = 'DELETE_PROJECT_TAG_REQ';
export const DELETE_PROJECT_TAG_OK = 'DELETE_PROJECT_TAG_OK';

export const CHANGE_SERVER_TYPE_REQ = 'CHANGE_SERVER_TYPE_REQ';

export const SEND_INTENT_REQ = 'SEND_INTENT_REQ';
export const SEND_PREPARED_INTENT_REQ = 'SEND_PREPARED_INTENT_REQ';

export const SEND_MESSAGE_PROJECT_REQ = 'SEND_MESSAGE_PROJECT_REQ';

export const CLEAR_CHAT_MESSAGES = 'CLEAR_CHAT_MESSAGES';

export const CLEAR_CHAT_AND_DIALOG_REQ = 'CLEAR_CHAT_AND_DIALOG_REQ';
export const CLEAR_CHAT_AND_DIALOG_OK = 'CLEAR_CHAT_AND_DIALOG_OK';

export const RELOAD_PROJECT_REQ = 'RELOAD_PROJECT_REQ';
export const RELOAD_PROJECT_OK = 'RELOAD_PROJECT_OK';

export const MODEL_UPDATED_OK = 'MODEL_UPDATED_OK';
export const MODEL_UPDATED_ERR = 'MODEL_UPDATED_ERR';

export const RESET_PROJECT_REQ = 'RESET_PROJECT_REQ';
export const RESET_PROJECT_OK = 'RESET_PROJECT_OK';

export const RESET_PROJECT_ON_UI_REQ = 'RESET_PROJECT_ON_UI_REQ';

export const SET_PROJECT_OPTIONS_REQ = 'SET_PROJECT_OPTIONS_REQ';
export const SET_PROJECT_OPTIONS_OK = 'SET_PROJECT_OPTIONS_OK';

export const GET_ANALYTICS_INTENTS_REQ = 'GET_ANALYTICS_INTENTS_REQ';
export const GET_ANALYTICS_INTENTS_OK = 'GET_ANALYTICS_INTENTS_OK';

export const READ_LOGS_REQ = 'READ_LOGS_REQ';
export const READ_LOGS_OK = 'READ_LOGS_OK';

export const EXPORT_LOGS_REQ = 'EXPORT_LOGS_REQ';
export const EXPORT_LOGS_OK = 'EXPORT_LOGS_OK';

export const EXPORT_DIALOGS_REQ = 'EXPORT_DIALOGS_REQ';
export const EXPORT_DIALOGS_OK = 'EXPORT_DIALOGS_OK';

export const GET_PROJECT_STATISTICS_BY_RANGE_REQ = 'GET_PROJECT_STATISTICS_BY_RANGE_REQ';
export const GET_PROJECT_STATISTICS_BY_RANGE_OK = 'GET_PROJECT_STATISTICS_BY_RANGE_OK';

export const GET_RESOURCE_USAGE_PER_PROJECT_REQ = 'GET_RESOURCE_USAGE_PER_PROJECT_REQ';
export const GET_RESOURCE_USAGE_PER_PROJECT_OK = 'GET_RESOURCE_USAGE_PER_PROJECT_OK';

export const GET_PROJECT_STATISTICS_BY_DATES_REQ = 'GET_PROJECT_STATISTICS_BY_DATES_REQ';

export const GET_PROJECT_STATISTICS_MIN_MAX_DATES_REQ = 'GET_PROJECT_STATISTICS_MIN_MAX_DATES_REQ';
export const GET_PROJECT_STATISTICS_MIN_MAX_DATES_OK = 'GET_PROJECT_STATISTICS_MIN_MAX_DATES_OK';

export const GET_PROJECT_LOCATION_STATISTICS_BY_DATES_REQ = 'GET_PROJECT_LOCATION_STATISTICS_BY_DATES_REQ';
export const GET_PROJECT_LOCATION_STATISTICS_BY_DATES_OK = 'GET_PROJECT_LOCATION_STATISTICS_BY_DATES_OK';


export const GET_PATTERN_STATISTICS_BY_DATES_REQ = 'GET_PATTERN_STATISTICS_BY_DATES_REQ';
export const GET_PATTERN_STATISTICS_BY_DATES_OK = 'GET_PATTERN_STATISTICS_BY_DATES_OK';

export const REMEMBER_PROJECT_ENVIRONMENT_REQ = 'REMEMBER_PROJECT_ENVIRONEeNT_REQ';


export const GET_TEST_CONVERSATION_REQ = 'GET_TEST_CONVERSATION_REQ';
export const GET_TEST_CONVERSATION_OK = 'GET_TEST_CONVERSATION_OK';

export const CREATE_TEST_CONVERSATION_REQ = 'CREATE_TEST_CONVERSATION_REQ';
export const CREATE_TEST_CONVERSATION_OK = 'CREATE_TEST_CONVERSATION_OK';

export const OPEN_TEST_CONVERSATION_REQ = 'OPEN_TEST_CONVERSATION_REQ';

export const UPDATE_TEST_CONVERSATION_REQ = 'UPDATE_TEST_CONVERSATION_REQ';
export const UPDATE_TEST_CONVERSATION_OK = 'UPDATE_TEST_CONVERSATION_OK';

export const DELETE_TEST_CONVERSATION_REQ = 'DELETE_TEST_CONVERSATION_REQ';
export const DELETE_TEST_CONVERSATION_OK = 'DELETE_TEST_CONVERSATION_OK';

export const GET_TEST_CONVERSATIONS_REQ = 'GET_TEST_CONVERSATIONS_REQ';
export const GET_TEST_CONVERSATIONS_OK = 'GET_TEST_CONVERSATIONS_OK';

export const EXPORT_TEST_CONVERSATIONS_REQ = 'EXPORT_TEST_CONVERSATIONS_REQ';
export const EXPORT_TEST_CONVERSATIONS_OK = 'EXPORT_TEST_CONVERSATIONS_OK';

export const IMPORT_TEST_CONVERSATIONS_REQ = 'IMPORT_TEST_CONVERSATIONS_REQ';
export const IMPORT_TEST_CONVERSATIONS_OK = 'IMPORT_TEST_CONVERSATIONS_OK';

export const CHANGE_PROJECT_TEST_MODE_REQ = 'CHANGE_PROJECT_TEST_MODE_REQ';
export const CHANGE_PROJECT_TEST_MODE_OK = 'CHANGE_PROJECT_TEST_MODE_OK';

export const SEND_PROJECT_QR_CODE_REQ = 'SEND_PROJECT_QR_CODE_REQ';
export const SEND_PROJECT_QR_CODE_OK = 'SEND_PROJECT_QR_CODE_OK';

export const MARK_LOGS_AS_READ_REQ = 'MARK_LOGS_AS_READ_REQ';
export const MARK_LOGS_AS_READ_OK = 'MARK_LOGS_AS_READ_OK';

export const SHOW_MORE_INFO_ABOUT_COMMANDS_REQ = 'SHOW_MORE_INFO_ABOUT_COMMANDS_REQ';
export const SHOW_MORE_INFO_ABOUT_VISUAL_STATE_REQ = 'SHOW_MORE_INFO_ABOUT_VISUAL_STATE_REQ';

export const APPLY_VISUAL_STATE_IN_DEBUG_CHAT_REQ = 'APPLY_VISUAL_STATE_IN_DEBUG_CHAT_REQ';
export const APPLY_VISUAL_STATE_IN_DEBUG_CHAT_OK = 'APPLY_VISUAL_STATE_IN_DEBUG_CHAT_OK';

export const GET_BTN_OPTIONS_REQ = 'GET_BTN_OPTIONS_REQ';
export const GET_BTN_OPTIONS_OK = 'GET_BTN_OPTIONS_OK';

export const ADD_BTN_OPTIONS_REQ = 'ADD_BTN_OPTIONS_REQ';
export const ADD_BTN_OPTIONS_OK = 'ADD_BTN_OPTIONS_OK';

export const UPDATE_BTN_OPTIONS_REQ = 'UPDATE_BTN_OPTIONS_REQ';
export const UPDATE_BTN_OPTIONS_OK = 'UPDATE_BTN_OPTIONS_OK';

export const DELETE_BTN_OPTIONS_REQ = 'DELETE_BTN_OPTIONS_REQ';
export const DELETE_BTN_OPTIONS_OK = 'DELETE_BTN_OPTIONS_OK';

export const SEND_BILLING_TOKEN_REQ = 'SEND_BILLING_TOKEN_REQ';
export const SEND_BILLING_TOKEN_OK = 'SEND_BILLING_TOKEN_OK';

export const CREATE_PAYPAL_ORDER_REQ = 'CREATE_PAYPAL_ORDER_REQ';

//todo: move actions related to the payment to user actions

export const CHECK_IS_PAYPAL_ORDER_APPROVED_REQ = 'CHECK_IS_PAYPAL_ORDER_APPROVED_REQ';

export const GET_STRIPE_PAYMENT_INTENT_REQ = 'GET_STRIPE_PAYMENT_INTENT_REQ';
export const PROCEED_STRIPE_PAYMENT_REQ = 'PROCEED_STRIPE_PAYMENT_REQ';

export const CHANGE_PAYMENT_METHOD_REQ = 'CHANGE_PAYMENT_METHOD_REQ';

export const DELETE_PAYMENT_METHOD_REQ = 'DELETE_PAYMENT_METHOD_REQ';

export const CHARGE_USER_REQ = 'CHARGE_USER_REQ';
export const CHARGE_USER_OK = 'CHARGE_USER_OK';

export const APPLY_PROMO_CODE_REQ = 'APPLY_PROMO_CODE_REQ';
export const APPLY_PROMO_CODE_OK = 'APPLY_PROMO_CODE_OK';

export const GET_LOG_IMAGE_REQ = 'GET_LOG_IMAGE_REQ';
export const GET_LOG_IMAGE_OK = 'GET_LOG_IMAGE_OK';

export const SAVE_VISUAL_STATE_REQ = 'SAVE_VISUAL_STATE_REQ';
export const SAVE_VISUAL_STATE_OK = 'SAVE_VISUAL_STATE_OK';
export const SHOW_VISUAL_STATE_PANEL_REQ = 'SHOW_VISUAL_STATE_PANEL_REQ';
export const HIDE_VISUAL_STATE_PANEL_REQ = 'HIDE_VISUAL_STATE_PANEL_REQ';
export const SELECT_VISUAL_STATE_REQ = 'SELECT_VISUAL_STATE_REQ';

export const SAVE_AUTH_DATA_REQ = 'SAVE_AUTH_DATA_REQ';
export const SAVE_AUTH_DATA_OK = 'SAVE_AUTH_DATA_OK';

export const SHOW_AUTH_DATA_PANEL_REQ = 'SHOW_AUTH_DATA_PANEL_REQ';
export const HIDE_AUTH_DATA_PANEL_REQ = 'HIDE_AUTH_DATA_PANEL_REQ';

export const SHOW_BIG_LOG_IMAGE_REQ = 'SHOW_BIG_LOG_IMAGE_REQ';

export const UPDATE_PROJECT_CONNECT_DETAILS_REQ = 'UPDATE_PROJECT_CONNECT_DETAILS_REQ';
export const UPDATE_PROJECT_CONNECT_DETAILS_OK = 'UPDATE_PROJECT_CONNECT_DETAILS_OK';

export const UPDATE_STUDIO_CONNECT_DETAILS_REQ = 'UPDATE_STUDIO_CONNECT_DETAILS_REQ';
export const UPDATE_STUDIO_CONNECT_DETAILS_OK = 'UPDATE_STUDIO_CONNECT_DETAILS_OK';

export const GET_TEXT_TO_SPEACH_REQ = 'GET_TEXT_TO_SPEACH_REQ';

export const UPLOAD_ALAN_BTN_LOGO_REQ = 'UPLOAD_ALAN_BTN_LOGO_REQ';

export const GET_COHORTS_REQ = 'GET_COHORTS_REQ';
export const GET_COHORTS_OK = 'GET_COHORTS_OK';

export const CREATE_COHORT_REQ = 'CREATE_COHORT_REQ';
export const CREATE_COHORT_OK = 'CREATE_COHORT_OK';

export const UPDATE_COHORT_REQ = 'UPDATE_COHORT_REQ';
export const UPDATE_COHORT_OK = 'UPDATE_COHORT_OK';

export const DELETE_COHORT_REQ = 'DELETE_COHORT_REQ';
export const DELETE_COHORT_OK = 'DELETE_COHORT_OK';

export const SEARCH_LOCATIONS_FOR_COHORT_REQ = 'SEARCH_LOCATIONS_FOR_COHORT_REQ';

export const SET_PROJECT_DECRIPTION_ERROR_OK = 'SET_PROJECT_DECRIPTION_ERROR_OK';

export const UPDATE_PROJECT_AFTER_MERGE_REQ = 'UPDATE_PROJECT_AFTER_MERGE_REQ';
export const UPDATE_PROJECT_AFTER_MERGE_OK = 'UPDATE_PROJECT_AFTER_MERGE_OK';

export const UPDATE_PROJECT_AFTER_CICD_SYNC_REQ = 'UPDATE_PROJECT_AFTER_CICD_SYNC_REQ';
export const UPDATE_PROJECT_AFTER_CICD_SYNC_OK = 'UPDATE_PROJECT_AFTER_CICD_SYNC_OK';

export const GET_DEFAULT_WAKEWORD_REQ = 'GET_DEFAULT_WAKEWORD_REQ';
export const GET_DEFAULT_WAKEWORD_OK = 'GET_DEFAULT_WAKEWORD_OK';

export const GET_DEFAULT_WAKEWORD_OPTIONS_OK = 'GET_DEFAULT_WAKEWORD_OPTIONS_OK';

export const GET_WAKEWORDS_REQ = 'GET_WAKEWORDS_REQ';
export const GET_WAKEWORDS_OK = 'GET_WAKEWORDS_OK';

export const SAVE_WAKEWORD_REQ = 'SAVE_WAKEWORD_REQ';
export const SAVE_WAKEWORD_OK = 'SAVE_WAKEWORD_OK';
export const SAVE_WAKEWORD_ERR = 'SAVE_WAKEWORD_ERR';

export const UPDATE_WAKEWORD_REQ = 'UPDATE_WAKEWORD_REQ';
export const UPDATE_WAKEWORD_OK = 'UPDATE_WAKEWORD_OK';

export const DELETE_WAKEWORD_REQ = 'DELETE_WAKEWORD_REQ';
export const DELETE_WAKEWORD_OK = 'DELETE_WAKEWORD_OK';

export const MANAGE_RUNTIME_ERRORS_REQ = 'MANAGE_RUNTIME_ERRORS_REQ';
export const MANAGE_RUNTIME_ERRORS_OK = 'MANAGE_RUNTIME_ERRORS_OK';

export const GET_TRANSFORM_INFO_REQ = 'GET_TRANSFORM_INFO_REQ';
export const GET_TRANSFORM_INFO_OK = 'GET_TRANSFORM_INFO_OK';


export const COPY_TRANSFORM_ROW_REQ = 'COPY_TRANSFORM_ROW_REQ';

export const RUN_CODE_GENERATOR_REQ = 'RUN_CODE_GENERATOR_REQ';
export const RUN_CODE_GENERATOR_OK = 'RUN_CODE_GENERATOR_OK';

export const SET_SCRIPTS_GRAPH_CACHE_REQ = 'SET_SCRIPTS_GRAPH_CACHE_REQ';
export const SET_SCRIPTS_GRAPH_CACHE_OK = 'SET_SCRIPTS_GRAPH_CACHE_OK';

export const RESET_SCRIPTS_GRAPH_CACHE_REQ = 'RESET_SCRIPTS_GRAPH_CACHE_REQ';
export const RESET_SCRIPTS_GRAPH_CACHE_OK = 'RESET_SCRIPTS_GRAPH_CACHE_OK';

export const OPEN_LARGE_SCRIPT_REQ = 'OPEN_LARGE_SCRIPT_REQ';
export const OPEN_LARGE_SCRIPT_OK = 'OPEN_LARGE_SCRIPT_OK';